import { Route, Routes } from 'react-router-dom';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import { SignUpPage, SignUpVcfcPage, SuccessPage, SuccessVcfcPage } from '@pages';

export const Public = () => {
  return (
    <Routes>
      {PaletteUtils.isInsigniaPalette && <Route path={RoutePaths.signup.path} element={<SignUpPage />} />}
      {PaletteUtils.isVcfcPalette && <Route path={RoutePaths.signup.path} element={<SignUpVcfcPage />} />}
      {PaletteUtils.isInsigniaPalette && <Route path={RoutePaths.success.path} element={<SuccessPage />} />}
      {PaletteUtils.isVcfcPalette && <Route path={RoutePaths.success.path} element={<SuccessVcfcPage />} />}
    </Routes>
  );
};
